import { useEffect, useState } from "react";

// Shared dark/light toggle — used by SiteChrome's header (every app page) and the landing
// page's own nav (which bypasses SiteChrome entirely, see BARE_ROUTES). Both stay in sync
// automatically since neither is ever mounted at the same time as the other, and each reads
// the same localStorage key + <html data-theme> attribute the global CSS keys off of.
export function useTheme() {
  const [theme, setTheme] = useState<"dark" | "light">(() => {
    try { return (localStorage.getItem("sp-theme") as "dark" | "light") || "dark"; }
    catch { return "dark"; }
  });

  useEffect(() => {
    const root = document.documentElement;
    // Suppress transitions during the flip so every element recolors at once (no per-component
    // lag, e.g. the sidebar fading separately). Re-enable after the paint.
    root.classList.add("theme-switching");
    root.setAttribute("data-theme", theme);
    try { localStorage.setItem("sp-theme", theme); } catch {}
    const raf = requestAnimationFrame(() =>
      requestAnimationFrame(() => root.classList.remove("theme-switching")),
    );
    return () => cancelAnimationFrame(raf);
  }, [theme]);

  return { theme, toggleTheme: () => setTheme((t) => (t === "dark" ? "light" : "dark")) };
}
